import { Component, OnInit } from '@angular/core';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { NzMessageService } from 'ng-zorro-antd/message';
import { Router, ActivatedRoute } from "@angular/router";

import { AutorizadorService } from '../../services/autorizador.service';

@Component({
    selector: 'app-autorizador',
    templateUrl: './autorizador.component.html',
    styleUrls: ['./autorizador.component.css'],
    standalone: false
})
export class AutorizadorComponent implements OnInit {
  total = 11;
  loading = true;
  search; //String que irá guardar o que o usuário quer pesquisar
  isVisibleCancelFiltro = false;
  pageSize = 10;
  pageIndex = 1;
  isVisibleDetalhe = false;
  autorizadores = [];

  constructor(
    private message: NzMessageService,
    private route: ActivatedRoute,
    private router: Router,
    private autorizadorService: AutorizadorService,
  ) { }


  ngOnInit(): void {
  }

  ativar(idautorizador) {
    let idLoading = this.message.loading('Ativando autorizador...').messageId;
    this.autorizadorService.ativar(idautorizador).subscribe((i: any) => {
      this.message.remove(idLoading);
      this.message.success('Ativação realizada com SUCESSO!');
      this.loading = true;
      this.autorizadorService.all(this.pageIndex).subscribe((m: any) => {
        this.autorizadores = m.data.autorizador.data;
        this.total = m.data.autorizador.total;
        this.pageSize = m.data.autorizador.per_page;
        this.loading = false;
      });
    });
  }

  inativar(idautorizador) {
    let idLoading = this.message.loading('Inativando autorizador...').messageId;
    this.autorizadorService.inativar(idautorizador).subscribe((i: any) => {
      this.message.remove(idLoading);
      this.message.success('Inativação realizada com SUCESSO!');
      this.loading = true;
      this.autorizadorService.all(this.pageIndex).subscribe((m: any) => {
        this.autorizadores = m.data.autorizador.data;
        this.total = m.data.autorizador.total;
        this.pageSize = m.data.autorizador.per_page;
        this.loading = false;
      });
    });
  }

  onQueryParamsChange(params: NzTableQueryParams): void {
    this.autorizadorService.all(params.pageIndex).subscribe((m: any) => {
      this.pageIndex = params.pageIndex;
      this.autorizadores = m.data.autorizador.data;
      this.total = m.data.autorizador.total;
      this.pageSize = m.data.autorizador.per_page;
      this.loading = false;
    });
  }

  removerFiltro() {
    this.search = '';
    this.searchAutorizador();
    this.isVisibleCancelFiltro = false;
  }

  searchAutorizador() {
    if (this.search !== undefined) {
      this.isVisibleCancelFiltro = true;
      this.loading = true; 
 
      this.autorizadorService.all(this.pageIndex, this.search).subscribe((m: any) => {
        this.pageIndex = 1;
        this.autorizadores = m.data.autorizador.data;
        this.total = m.data.autorizador.total;
        this.pageSize = m.data.autorizador.per_page;
        this.loading = false;
      });
    } else {
      this.message.warning("Digite a sua pesquisa para continuar.");
    }

  }
}
